import { gql } from '@apollo/client';

export const QUERY_ONBOARDING_STEP5 = gql`
  query onBoardingStep5 {
    step5 {
      data {
        attributes {
          content {
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
            button {
              text
              link
            }
          }
        }
      }
    }
  }
`;
